"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _constants = require("../../constants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const PrizmSeparator = ({
  fill = '#fff'
}) => _react.default.createElement("svg", {
  width: "16px",
  height: "16px",
  viewBox: "0 0 16 16",
  style: {
    margin: '0 4px'
  }
}, _react.default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, _react.default.createElement("g", {
  fill: fill,
  transform: "translate(4.000000, 2.000000)"
}, _react.default.createElement("g", {
  transform: "translate(4.000000, 6.000000) rotate(-90.000000) translate(-4.000000, -6.000000) translate(-2.000000, 2.000000)"
}, _react.default.createElement("polygon", {
  points: "6 7.4 0.6 2 2 0.6 6 4.6 10 0.6 11.4 2"
})))));
const MDSSeparator = ({
  fill = '#b3b3b3'
}) => _react.default.createElement("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  style: {
    margin: '0 11px'
  }
}, _react.default.createElement("path", {
  fill: "none",
  stroke: fill,
  strokeLinecap: "square",
  strokeMiterlimit: "10",
  strokeWidth: "1",
  d: "M7 2l10 10L7 22"
}));
const Separator = (0, _react.memo)(({
  theme = {}
}) => {
  return theme.name !== _constants.THEMES.mds ? _react.default.createElement(PrizmSeparator, {
    fill: theme.colors.appFrame.breadcrumbs.separator
  }) : _react.default.createElement(MDSSeparator, {
    fill: theme.colors.appFrame.breadcrumbs.separator
  });
});
var _default = exports.default = (0, _styledComponents.withTheme)(Separator);